module.exports = __webpack_public_path__ + "img/HDBANK.63ab7768.svg";